import { React } from '@digsup/core-ui';
import { Relationship } from '@digsup/components-relationship';
import { Avatar } from '@digsup/components-avatar';
import { Icon } from '@digsup/components-icon';
import { Image } from '@digsup/components-image';

import { FeaturesItem } from './FeaturesItem';
import collaborateImg from './assets/collaborate.png';
import collaborate2xImg from './assets/collaborate@2x.png';
import collaborate3xImg from './assets/collaborate@3x.png';
import collaborateMobileImg from './assets/collaborate-mobile.png';
import collaborateMobile2xImg from './assets/collaborate-mobile@2x.png';
import collaborateMobile3xImg from './assets/collaborate-mobile@3x.png';

export const FeatureCollaborate = () => (
  <FeaturesItem
    title="Share &amp; collaborate"
    description="Share your subscription with others in your household or collaborate with friends and family to list and sell"
    icon={
      <Relationship size="medium" joinIconName="plus">
        <Avatar type="co-owner" variant="user" />
        <Icon name="house" />
      </Relationship>
    }
    media={
      <div className="l-homepage-features__collaborate-media">
        <div className="l-homepage-features__collaborate-media-img">
          <Image
            src={collaborateImg}
            srcset={`
              ${collaborateMobileImg} 473w,
              ${collaborateImg} 494w,
              ${collaborateMobile2xImg} 946w,
              ${collaborate2xImg} 988w,
              ${collaborateMobile3xImg} 1419w,
              ${collaborate3xImg} 1482w
            `}
            sizes="(max-width: 999px) 473px, 494px"
            placeholderImage=""
            alt="Share and collaborate"
          />
        </div>
      </div>
    }
  />
);
